<template>
    <v-dialog v-model="modalShow" persistent max-width="60%">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col class="text-center py-8 pb-4" cols="12">
              <h1>Associar lotes a nota fiscal</h1>
            </v-col>
            <v-col class="text-right px-1 ml-1" cols="4">
              <p class="mb-0"><b>N° NF: </b>{{notaFiscal.numero}}</p>
            </v-col>
            <v-col class="text-center ml-6" cols="3">
              <p class="mb-0"><b>Data de emissão: </b>{{notaFiscal.dt_emissao | formatDate}}</p>
            </v-col>
            <v-col class="text-left px-1 ml-3" cols="4">
              <p class="mb-0"><b>Valor NF: </b>R$ {{notaFiscal.valor | formatPrice}}</p>
            </v-col>
          </v-row>
          <v-col class="pa-0" cols="12">
            <LotesList
              :list="listLote"
              :value="totalValue"
              :nfId="notaFiscal.id"
              :getLotesAssociados="(list_lotes) => listLotesAssociados = list_lotes"
            />
          </v-col>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-col class="text-left px-4 pt-0" cols="12" sm="6" md="6">
              <v-btn
                small
                height="30px"
                color="primary"
                depressed
                outlined
                @click="showClose()"
              >
                Cancelar
              </v-btn>
            </v-col>
            <v-col class="text-right px-4 pt-0" cols="12" sm="6" md="6">
              <v-btn
                color="primary"
                small
                height="30px"
                depressed
                @click="associaLotes(listLotesAssociados)"
              >
                Salvar
              </v-btn>
            </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from "vuex"
import LotesList from './LotesList'
import moment from 'moment';
moment.locale("pt-BR");
export default {
  components: {
    LotesList
  },
  data() {
    return {
      modalShow: false,
      listLote: [],
      listLotesAssociados: [],
      totalValue: {},
    };
  },
  computed:{
    ...mapState({
      grupoEconomico: state => state.permissions.grupoEconomico,
      userData: (state) => state.userData.userData,
    })
  },
  watch: {
    showOpen(val) {
      this.modalShow = val
    },
    listLotes(val) {
      this.listLote = val;

      let lotesAssociados = val.map(item => 
      {
        if(item.is_associada && item.nfs_associadas.includes(this.notaFiscal.id))
          return item.arq_vl_calculado;

        return 0;
      });
      
      let vlTotal = lotesAssociados.reduce((total, item) => total + item, 0);
      this.totalValue = { vl_total_lotes: vlTotal };
    },
  },
  filters: {
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    formatDate(date) {
      return moment(date).format("L");
    },
  },
  props: {
    showOpen: Boolean,
    showClose: Function,
    listLotes: Array,
    associaLotes: Function,
    notaFiscal: Object
  },
};
</script>

<style scoped>
</style>